import MuiList from '@mui/material/List';
import MuiListItem from '@mui/material/ListItem';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import MuiListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

export const StyledList = styled(MuiList)({}) as typeof MuiList;
export const StyledListItem = styled(MuiListItem)({}) as typeof MuiListItem;
export const StyledListItemIcon = styled(MuiListItemIcon)({}) as typeof MuiListItemIcon;
export const StyledListItemText = styled(MuiListItemText)({}) as typeof MuiListItemText;
